export default __webpack_public_path__ + "static/media/icon-metrics-load.b1a3d47c.svg";